import { EBoardSetting } from '../../../../TabDetails/components/TabDetails/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import { SegmentBoardOption } from '../../../../../../../../../middlewares/segment/trackEntities/boardEvents';

export const onFinish = (
    key: EBoardSetting,
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentBoardEvent.TUTORIAL_FINISH, {
            name: SegmentBoardOption.TYPE,
            value: key,
        }));
    }
    return action;
}
